import { render, staticRenderFns } from "./DataSourceInspect.vue?vue&type=template&id=06a01533&"
import script from "./DataSourceInspect.vue?vue&type=script&lang=js&"
export * from "./DataSourceInspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports